import { Box, IconButton, Link as MuiLink } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { DensityStyleTypes } from '../../../../types'
import { DisabledIconButton } from '../../../DataGrid/style'
import PandaDocLinkIcon from '../../../Icons/PandaDockLinkIcon'

interface RenderContractProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  navigate?: (route: string) => void
}

const RenderContractCell: React.FC<RenderContractProps> = ({ params, densityStyles, navigate: _navigate }) => {
  const previewUrl = `https://app.pandadoc.com/a/#/documents`
  const { contractId } = params?.row ?? null
  const contractUrl = previewUrl && contractId ? `${previewUrl}/${contractId}` : null
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {contractUrl ? (
        <MuiLink href={`${contractUrl}`} onClick={e => e.stopPropagation()} target="_blank" rel="noopener noreferrer">
          <IconButton>
            <PandaDocLinkIcon size={densityStyles.globeSize} />
          </IconButton>
        </MuiLink>
      ) : (
        <DisabledIconButton disabled>
          <PandaDocLinkIcon size={densityStyles.globeSize} />
        </DisabledIconButton>
      )}
    </Box>
  )
}
export default RenderContractCell
